export const detectMovedItem = (prevItems, newItems) => {
    let item = null;
    let maxMoveDistance = 0;
    prevItems.forEach((prevItem, oldIndex) => {
        const newIndex = newItems.findIndex((newItem) => newItem.id === prevItem.id);
        if (newIndex !== oldIndex) {
            const moveDistance = Math.abs(newIndex - oldIndex);
            if (moveDistance > maxMoveDistance) {
                maxMoveDistance = moveDistance;
                item = prevItem;
            }
        }
    });
    if (!item)
        return null;
    const changedItem = item;
    const newIndex = newItems.findIndex((item) => item.id === changedItem.id);
    let newOrderIndex;
    if (newIndex === 0) {
        newOrderIndex = newItems[1].orderIndex - 1;
    }
    else if (newIndex === newItems.length - 1) {
        newOrderIndex = newItems[newIndex - 1].orderIndex + 1;
    }
    else {
        const prevIndex = newItems[newIndex - 1].orderIndex;
        const nextIndex = newItems[newIndex + 1].orderIndex;
        newOrderIndex = (prevIndex + nextIndex) / 2;
    }
    const updatedItems = newItems.map((item) => (item.id === changedItem.id ? Object.assign(Object.assign({}, item), { orderIndex: newOrderIndex }) : item));
    return { updatedItems, changedItemId: changedItem.id, newOrderIndex };
};
